import React from "react";
import Box from "@mui/material/Box";
import { MdLocationOn } from "react-icons/md";
import {eventLocation as classes} from './styles';

export interface Props {
  name: string;
}

const EventLocation = ({ name }: Props) => {
  return (
    <Box sx={classes.cardContentItem}>
      <MdLocationOn
        style={{ marginRight: "10px", color: "#A8A8A8", fontSize: "16px" }}
      />
      {name}
    </Box>
  );
};

export default EventLocation;
